import Vue from 'vue';
import _store from '@/store';

export { _store as store };

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Variable                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//
export const state = {
  store: _store.state,
  // States from Vuex store
  local: Vue.observable({
    // Setup local state here (States which don't shared or long-term keeping);
    form: {
      id: '',
    },

    isProcessing: false,

    //manual data
    studentCode: '',
    selectedStudent: null,
    selectedAcademicPeriod: null,
    selectedStudentEnroll: null,
    currentAcademicPeriod: null,
    studentEnroll: null,
    studentEnrolls: [],
    studentEnrollDetails: [],
    students: [],

    //add page
    classRooms: [],
  })
};

export const template = {
  table: {
    header: [
      {title: 'student-enroll.no', id: 'no'},
      {title: 'student-enroll.subject-code', id: 'SubjectCode'},
      {title: 'student-enroll.subject-name', id: 'subjectName'},
      {title: 'student-enroll.credit', id: 'credit'},
      {title: 'student-enroll.section-no', id: 'sectionNo'},
      {title: 'student-enroll.learn-span-no', id: 'learnSpanNo'},
      {title: 'student-enroll.student-qty', id: 'studentQty'},
      {title: 'student-enroll.teacher', id: 'teacher'},
      {title: 'student-enroll.register-or-drop', id: 'idDrop'},
    ]
  },
  tableAdd: {
    header: [
      {title: 'student-enroll.no', id: 'no'},
      {title: 'student-enroll.subject-code', id: 'SubjectCode'},
      {title: 'student-enroll.subject-name', id: 'subjectName'},
      {title: 'student-enroll.credit', id: 'credit'},
      {title: 'student-enroll.section-no', id: 'sectionNo'},
      {title: 'student-enroll.learn-span-no', id: 'learnSpanNo'},
      {title: 'student-enroll.student-qty', id: 'studentQty'},
      {title: 'student-enroll.teacher', id: 'teacher'},
      {title: 'student-enroll.register-or-drop', id: 'idDrop'},
    ]
  }
};


//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Function                                                              //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//

export const initData = async (func) => {
  //use state
  if (func.getAcademicPeriods && (!state.store.AcademicPeriod.academicPeriods || state.store.AcademicPeriod.academicPeriods.length === 0)) {
    await func.getAcademicPeriods();
  }

  //use local
  if (func.getCurrentAcademicPeriodConfig && !state.local.academicPeriodConfig) {
    state.local.currentAcademicPeriod = await func.getCurrentAcademicPeriodConfig();
    state.local.selectedAcademicPeriod = state.store.AcademicPeriod.academicPeriods.find(item => {
      return item.periodCode === state.local.currentAcademicPeriod.learnPeriodCode
    });
  }

};

export const loadData = async (func) => {

  if(state.local.selectedStudent && state.local.selectedStudent.id){
    let payload = {
      studentEnrollFilterInput: {
        studentId: state.local.selectedStudent.id,
      }
    };

    if (func.getStudentEnrollsByFilter) {
      state.local.studentEnrolls = await func.getStudentEnrollsByFilter(payload);
    }
  }else{
    state.local.studentEnroll = null;
    state.local.studentEnrolls = [];
    state.local.studentEnrollDetails = [];
  }
};

export const filterStudentEnrollByAcademicPeriod = () => {
  if (state.local.studentEnrolls && state.local.studentEnrolls.length > 0) {

    state.local.studentEnroll = state.local.studentEnrolls.find(item => {
      return item.periodCode === state.local.selectedAcademicPeriod.periodCode
    });

    state.local.studentEnrollDetails = [];
    if (state.local.studentEnroll) {

      let localData = JSON.parse(JSON.stringify(state.local.studentEnroll.studentEnrollDetails));
      state.local.studentEnrollDetails = localData.map(item => {
        return {
          ...item,
          isDrop: !item.isDrop, //for display
          canRegister: item.classSection.studentRegisterQty < item.classSection.studentQty,
        }
      });
    }

  }
};

//------------------------------------------------------------------------------------------------------//
//                                                                                                      //
//                                Private Function                                                      //
//                                                                                                      //
//------------------------------------------------------------------------------------------------------//

